'use strict';

// デバイス情報を取得
export const INITIALIZE_DEVICE_INFO = 'INITIALIZE_DEVICE_INFO';

// Cognitoインスタンス初期化してIdentityId取得する
export const INITIALIZE_COGNITO = 'INITIALIZE_COGNITO';
export const UPDATE_COGNITO_CREDENTIALS = 'UPDATE_COGNITO_CREDENTIALS';

// カメラのイメージをアップロードする
export const RESET_SCAN_DISC_DATA        = 'RESET_SCAN_DISC_DATA';
export const UPLOAD_CAMERA_IMAGE         = 'UPLOAD_CAMERA_IMAGE';
export const UPLOAD_CAMERA_IMAGE_SUCCESS = 'UPLOAD_CAMERA_IMAGE_SUCCESS';
export const UPLOAD_CAMERA_IMAGE_FAILURE = 'UPLOAD_CAMERA_IMAGE_FAILURE';
export const CHANGE_UPLOADING_PROGRESS   = 'CHANGE_UPLOADING_PROGRESS';

// ディスクデータの表示
export const RECEIVE_DISC_DATA         = 'RECEIVE_DISC_DATA';
export const RECEIVE_DISC_DATA_FAILURE = 'RECEIVE_DISC_DATA_FAILURE';

// SignedCookieをゲット
export const RESET_SIGNED_COOKIE = 'RESET_SIGNED_COOKIE';
export const GET_SIGNED_COOKIE = 'GET_SIGNED_COOKIE';
export const GET_SIGNED_COOKIE_SUCCESS = 'GET_SIGNED_COOKIE_SUCCESS';
export const GET_SIGNED_COOKIE_FAILURE = 'GET_SIGNED_COOKIE_FAILURE';

// 問い合わせ送信
export const SEND_INQUIRY = 'SEND_INQUIRY';
export const SEND_INQUIRY_SUCCESS = 'SEND_INQUIRY_SUCCESS';
export const SEND_INQUIRY_FAILURE = 'SEND_INQUIRY_FAILURE';

// ドキュメントダウンロードするための情報送信
export const SEND_INFO_FOR_DOCUMENT_DOWNLOAD = 'SEND_INFO_FOR_DOCUMENT_DOWNLOAD';
export const SEND_INFO_FOR_DOCUMENT_DOWNLOAD_SUCCESS = 'SEND_INFO_FOR_DOCUMENT_DOWNLOAD_SUCCESS';
export const SEND_INFO_FOR_DOCUMENT_DOWNLOAD_FAILURE = 'SEND_INFO_FOR_DOCUMENT_DOWNLOAD_FAILURE';

// 再生したよ
export const PLAY_CONTENT = 'PLAY_CONTENT';
export const PLAY_CONTENT_SUCCESS = 'PLAY_CONTENT_SUCCESS';
export const PLAY_CONTENT_FAILURE = 'PLAY_CONTENT_FAILURE';

// アンケート回答
export const SEND_ANSWER = 'SEND_ANSWER';
export const SEND_ANSWER_SUCCESS = 'SEND_ANSWER_SUCCESS';
export const SEND_ANSWER_FAILURE = 'SEND_ANSWER_FAILURE';

// コンテンツリストのスクロールポジション変わった
export const UPDATE_CONTENTS_LIST_SCROLL_POSITION = 'UPDATE_CONTENTS_LIST_SCROLL_POSITION';

// スナックバー
export const SHOW_SNACK_BAR = 'SHOW_SNACK_BAR';

// LINEでコンテンツを取得
export const GET_LINE_CONTENTS = 'GET_LINE_CONTENTS';
export const GET_LINE_CONTENTS_SUCCESS = 'GET_LINE_CONTENTS_SUCCESS';
export const GET_LINE_CONTENTS_FAILURE = 'GET_LINE_CONTENTS_FAILURE';



// WEBPACK FOOTER //
// ./src/store/types.js